import React from 'react';

const HeartbeatIcon = ({ color = 'currentColor', size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 12" fill="none" style={{ marginRight: 6 }}>
    <path
      d="M0.75 6H3.111C3.628 6 4.133 5.84 4.555 5.541C4.978 5.242 5.297 4.82 5.469 4.332L7.44 -1.25L10 6L12.56 13.25L14.54 7.665C14.712 7.178 15.032 6.757 15.454 6.458C15.876 6.16 16.379 6 16.896 6H19.25"
      stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      transform="translate(0, 1)"
    />
  </svg>
);

export default HeartbeatIcon;
